'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _exposeHandlers = require('recompose-scope/exposeHandlers');

var _exposeHandlers2 = _interopRequireDefault(_exposeHandlers);

var _linkHandlersBefore = require('coact-utils/linkHandlersBefore');

var _linkHandlersBefore2 = _interopRequireDefault(_linkHandlersBefore);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _propTypes2.default.func;

var enhancer = (0, _composeWithScope2.default)((0, _injectProps2.default)({
  onFocus: func,
  onBlur: func
}), (0, _withState2.default)('info', 'setInfo', { isFocused: false, isTouched: false }), (0, _exposeProps2.default)(function (_ref) {
  var info = _ref.info;
  return _extends({}, info);
}), (0, _exposeHandlers2.default)((0, _linkHandlersBefore2.default)({
  onFocus: function onFocus(_ref2) {
    var setInfo = _ref2.setInfo;
    return function () {
      return setInfo(function (_ref3) {
        var isTouched = _ref3.isTouched;
        return { isFocused: true, isTouched: isTouched };
      });
    };
  },
  onBlur: function onBlur(_ref4) {
    var setInfo = _ref4.setInfo;
    return function () {
      return setInfo({ isFocused: false, isTouched: true });
    };
  }
})));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'provideActiveInfo');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/provideActiveInfo.js
// module id = 1686
// module chunks = 0